<p *ngIf="title" class="title">{{ title }}</p>
<p *ngIf="subtitle" class="subtitle">{{ subtitle }}</p>
<mat-dialog-content>
  <ng-content select="[content]"></ng-content>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  <ng-content select="[actions]"></ng-content>
</mat-dialog-actions>